module.exports = __webpack_public_path__ + "static/media/mx-circle-01.a70d3b97.png";